import { Component, OnInit } from '@angular/core';
import { MaintenanceService } from '../../services/maintenance.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PositionTypesService } from '../services/position-types.service';
import { PositionTypeResource } from 'src/app/client-api.service';
import { PanelSize } from 'src/app/shared/tcc-ui/simple-panel/models';

@Component({
  selector: 'app-position-types-upsert',
  templateUrl: './position-types-upsert.component.html',
  styleUrls: ['./position-types-upsert.component.scss']
})
export class PositionTypesUpsertComponent implements OnInit {

  addOrEdit: 'add' | 'edit';
  duplicateKey = false;
  currentPositionType: PositionTypeResource | undefined;
  currentPositionTypeId = 0;
  panalSize: PanelSize = 'small';
  state: 'initializing' | 'loading' | 'ready' | 'saving';  

  positionTypesFormGroup = new FormGroup({
    positionTypeId: new FormControl(0, { nonNullable: true }),    
    name: new FormControl('', { nonNullable: true, validators: Validators.required }),    
    isService: new FormControl(false, { nonNullable: true, validators: Validators.required })
  });

  constructor(private activatedRoute: ActivatedRoute,
              private maintenanceService: MaintenanceService,              
              private positionTypesService: PositionTypesService,
              private router: Router) {
    this.state = 'initializing';  
    this.addOrEdit = 'edit';

  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(routeParam => {
      this.currentPositionTypeId = routeParam['id'];      
      if(routeParam['id'] !== '0') {
        this.addOrEdit = 'edit';
        this.getPositionType(this.currentPositionTypeId);        
      }
      else {
        this.addOrEdit = 'add';
        this.state = 'ready';        
        this.positionTypesFormGroup.reset();
      }
    });    
  }

  close() {
    this.maintenanceService.setMaintenanceComponenetPanelSize('small');
    this.router.navigate(['.'], { relativeTo: this.activatedRoute.parent });
  }

  getPositionType(id: any) {
    this.state = 'loading';
    this.positionTypesService.getPositionType(id)
        .subscribe(
          res => {
            this.state = 'ready';
            this.currentPositionType = res;
            this.positionTypesFormGroup.patchValue({            
              positionTypeId: res.positionTypeId,
              name: res.name,
              isService: res.isService
            });
          },
          err => {
            this.state = 'ready';
            alert('Error getting Position Type from database!');
          });
  }

  isChanged(field: string) {
    return this.positionTypesFormGroup.get(field)?.dirty;
  }

  onSubmit() {

    if(this.addOrEdit === 'add') {
      this.positionTypesFormGroup.controls['positionTypeId'].setValue(0); 
    }

    this.positionTypesFormGroup.controls['name'].enable();
    this.positionTypesFormGroup.controls['isService'].enable();

    const positionTypeResource: PositionTypeResource = this.positionTypesFormGroup.getRawValue();

    this.positionTypesService.putPositionType(positionTypeResource).subscribe(
      res => {
        this.positionTypesService.setPositionTypes();
        this.close();
      },
      err => {
        alert('Error adding Position Type!');
      });
  }
}
